import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import Collapse from '@mui/material/Collapse';
import TableContainer from '@mui/material/TableContainer';
import {
  UilPlus,
  UilCog,
  UilAngleDown,
  UilAngleUp
} from "@iconscout/react-unicons";
import { formatDate, isNull } from "../../utils/Utils";
import Color from "../../enum/Color";
import CreateButton from "../Common/CreateButton";
import SubscriptionModal from "../Modal/SubscriptionModal";
import SubscriptionStatusEnum from "../../enum/SubscriptionStatusEnum";
import SubscriptionInvoices from "../Subscriptions/SubscriptionInvoices";
import EmailTrackingItems from "./EmailTrackingItems";

const EmailTrackingItemsTable = (props) => {

  const data = props.data;

  return (
    <div className="Table">
      <Box sx={{ width: "100%" }}>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Email Subject</TableCell>
                <TableCell align="left">Token</TableCell>
                <TableCell align="left">Open Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isNull(data) ? (
                <Typography sx={{ m: 1, textAlign: "center" }}>
                  No data to show.
                </Typography>
              ) :
                data.map((item) => {
                  return (
                    <TableRow id={item.id}>
                      <TableCell component="th" scope="row">
                        {item.emailSubject}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {item.trackingToken}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {item.openCount}
                      </TableCell>
                    </TableRow>
                  );
                })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
};

export default EmailTrackingItemsTable;
